/*
 * @Author: your name
 * @Date: 2022-04-12 18:39:58
 * @LastEditTime: 2022-09-25 14:42:48
 * @LastEditors: zhaoyu zhaoyu@belink.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\clients\controller\currency\index.ts
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../libraries';
import { onCreateFactoryAuth } from '../system/auth';
import { onCreateFactoryUser } from '../system/userModel';
@BindAll()
export class CurrencyController {
  readonly User = onCreateFactoryUser();
  /**
   * 认证模块 默认从 cookie 中获取 token 不需要手动设置 token
   * 除非是地址栏解析或者其他方式等等
   * @memberof SystemController
   */
  readonly Auth = onCreateFactoryAuth();
  /** 图片验证码 */
  getImgCode(body) {
    return AjaxBasics.request<{ imgCode: string; sessionCode: string }>({
      ...EnumAPI.accountsvr_imgCode,
      body,
    });
  }
  /** lenovoId图片验证码 */
  getLidImgCode(t) {
    return AjaxBasics.request({
      ...EnumAPI.accountsvr_imgCode_lid,
      body: { t },
    });
  }
  /** 发送短信验证码 */
  sendCode(queryParams: {
    endpoint;
    receiverType;
    scene;
    imgCode;
    imgSession;
    t;
  }) {
    const api = this.Auth.AccessToken
      ? EnumAPI.accountsvr_SendCode
      : EnumAPI.accountsvr_SendCode_unLogin;
    return AjaxBasics.request({
      ...api,
      body: lodash.pickBy(
        lodash.pick(queryParams, [
          'endpoint',
          'receiverType',
          'scene',
          'imgCode',
          't',
        ]),
        lodash.identity,
      ),
      // queryParams,
      headers: { 'img-session': lodash.get(queryParams, 'imgSession') },
    });
  }

  /** 获取省份 */
  async getProvides() {
    return await AjaxBasics.request({ ...EnumAPI.usersvr_get_provinces });
  }

  /** 获取城市 */
  async getCitys(provideCode) {
    return await AjaxBasics.request({
      ...EnumAPI.usersvr_get_citys,
      body: { provideCode },
    });
  }

  /** 获取区县、街道 */
  async getDistrict(CityCode) {
    return await AjaxBasics.request({
      ...EnumAPI.usersvr_get_district,
      body: { CityCode },
    });
  }

  /**
   * 企业相关获取省份
   */
  async enterpriseGetProvides() {
    return await AjaxBasics.request({ ...EnumAPI.regionorg_get_provinces });
  }
  /**
   * 企业相关获取城市
   */
  async enterpriseGetCitys(provincecode) {
    return await AjaxBasics.request({
      ...EnumAPI.regionorg_get_citys,
      body: { provincecode },
    });
  }
  /**
   * 企业相关获取区县、街道
   */
  async enterpriseGetDistrict({ provincecode, citycode }) {
    return await AjaxBasics.request({
      ...EnumAPI.regionorg_get_district,
      body: { provincecode, citycode },
    });
  }
  /**
   * 加入组织管理员脱敏信息接口
   */
  async getOrganizationIdentityInfo(id) {
    return await AjaxBasics.request({
      ...EnumAPI.partner_get_employeeApplyIdentity,
      body: { id },
    });
  }

  /**
   * 窗口期，安全手机绑定发送验证码
   */
  async securitySendMsg(body) {
    return await AjaxBasics.request({
      ...EnumAPI.accountsvr_security_SendCode,
      body,
      headers: { 'img-session': lodash.get(body, 'imgSession') }
    });
  }

  /**
   * 忘记密码/重置密码，发送验证码
   */
  async pwdSendMsg(body) {
    return await AjaxBasics.request({
      ...EnumAPI.accountsvr_pwd_SendCode,
      body: lodash.assign(body, {forgetPwdToken: this.User.value.forgetPwdToken}),
      headers: { 'img-session': lodash.get(body, 'imgSession') }
    });
  }

}
